import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { MessageHandlerService } from '@core/services/message-handler/message-handler.service';
import { Store } from '@ngrx/store';
import { HasAccessDirective } from '@sharedModule/directives/has-access.directive';
import { MaterialModule } from '@sharedModule/material/material.module';
import { ConfirmationCommonDialogData } from '@sharedModule/models/confirmation-dialog.model';
import { CountryInfo } from '@sharedModule/models/country.model';
import { ConfirmationDialogService } from '@sharedModule/services/confirmation-dialog/confirmation-dialog.service';
import { GlobalService } from '@sharedModule/services/global.service';
import { deleteSourceCountry } from '@sharedModule/store/source-country/source-country.actions';
import { Subject, takeUntil } from 'rxjs';
import { CountrySettingsService } from '../../services/country-settings.service';
import { selectSourceCountry } from '@sharedModule/store/source-country/source-country.selector';

@Component({
  selector: 'app-source-country',
  standalone: true,
  imports: [CommonModule, MaterialModule, HasAccessDirective],
  templateUrl: './source-country.component.html',
  styleUrl: './source-country.component.scss',
})
export class SourceCountryComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'countryName',
    'countryCode',
    'currencySupported',
    'action',
  ];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataSource!: MatTableDataSource<any>;
  #destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private router: Router,
    private globalService: GlobalService,
    private messageHandlerService: MessageHandlerService,
    private countrySettingsService: CountrySettingsService,
    private confirmationDialogService: ConfirmationDialogService
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectSourceCountry)
      .pipe(takeUntil(this.#destroy$))
      .subscribe(data => {
        if (data) this.dataSource = new MatTableDataSource(data);
      });
  }

  onEdit(data: CountryInfo): void {
    this.globalService.putDataToStream(data);
    this.router.navigate(['/settings/edit-source-country']);
  }

  async onDeleteSourceCountry(data: CountryInfo): Promise<void> {
    const alertCommonDialogData: ConfirmationCommonDialogData = {
      title: '',
      message: `Are you sure you're going to delete this source country?`,
      submitButtonText: 'Confirm',
    };
    const isConfirmed =
      await this.confirmationDialogService.openConfirmationDialog(
        alertCommonDialogData
      );
    if (isConfirmed) {
      this.countrySettingsService
        .deleteSourceCountry({ srcCountryName: data.countryName })
        .pipe(takeUntil(this.#destroy$))
        .subscribe({
          next: x => {
            if (x.success) {
              this.messageHandlerService.show(x.message);
              this.store.dispatch(
                deleteSourceCountry({ srcCountryName: data.countryName })
              );
            }
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }
}
